import styled from '../../config/theme'

const Container = styled.div`

`

export {
  Container,
}
